import themeGet from '@styled-system/theme-get';
import * as T from 'prop-types';
import styled from 'styled-components/macro';

import { Flex } from '@olist/united';

import StepCard from './step-card';

const List = styled(Flex)`
  flex-direction: column;
  margin-top: ${themeGet('space.4')}px;

  > button:not(:last-child) {
    margin-bottom: ${themeGet('space.3')}px;
  }
`;

const StepCardList = ({ cards }) => (
  <List>
    {cards?.map(({ title, ...props }) => (
      <StepCard key={title} title={title} {...props} />
    ))}
  </List>
);

StepCardList.propTypes = {
  /**
   * What is the list of card properties?
   */
  cards: T.arrayOf(
    T.shape({
      isActive: T.bool,
      isCompleted: T.bool,
      isLoading: T.bool,
      isLocked: T.bool,
      title: T.string.isRequired,
    })
  ),
};

StepCardList.defaultProps = {
  cards: [],
};

export default StepCardList;
